/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Viewer_Ex_TitleInputs */

const en_viewer_ex_title = /** @type {(inputs: Viewer_Ex_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reading a response as a tree`)
};

const ko_viewer_ex_title = /** @type {(inputs: Viewer_Ex_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`응답을 트리로 읽기`)
};

const ja_viewer_ex_title = /** @type {(inputs: Viewer_Ex_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`レスポンスをツリーとして読む`)
};

/**
* | output |
* | --- |
* | "Reading a response as a tree" |
*
* @param {Viewer_Ex_TitleInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const viewer_ex_title = /** @type {((inputs?: Viewer_Ex_TitleInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Viewer_Ex_TitleInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_viewer_ex_title(inputs)
	if (locale === "ko") return ko_viewer_ex_title(inputs)
	return ja_viewer_ex_title(inputs)
});